module.exports = __webpack_public_path__ + "img/ssxyImg.cb686b58.png";